import { Button } from "PFComponents/button";
import InputFieldSet from "PFComponents/text/input_field_set";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./custom_link.less";

const CustomLink = ({ title, url, handleChange, handleRemove, formErrors = {} }) => {
  const { t } = useTranslation("saasAdmin");
  return (
    <div className={css.customLinkRow}>
      <InputFieldSet
        label={t("customization.customLinks.title")}
        value={title}
        handleChange={(val) => handleChange("title", val)}
        required="true"
        error={formErrors.title}
      />
      <InputFieldSet
        label={t("customization.customLinks.url")}
        value={url}
        handleChange={(val) => handleChange("url", val)}
        inputType="url"
        required="true"
        error={formErrors.url}
      />
      <span>
        <Button kind="danger" onClick={handleRemove} small type="button">
          {t("customization.customLinks.deleteButton")}
        </Button>
      </span>
    </div>
  );
};

CustomLink.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleRemove: PropTypes.func,
  formErrors: PropTypes.object
};

export default CustomLink;
